import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const ReviewsIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf054'}</MuiIcon>
    );
}
